module.exports = __webpack_public_path__ + "img/czzn_038.10f3b94f.png";